export enum MobileOptionVariant {
   Default = 'Default'
}
